<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="ArticlesAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="article in results" :key="article.id" :xl="6">
          <RecordArticle :article="article" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import Meta from '@mixins/Meta'
import RecordArticle from './components/RecordArticle'
import Table from '@mixins/Table'
import { prop } from 'rambda'

export default {
  mixins: [
    Meta('Articles'),
    Table,
  ],
  components: { RecordArticle },
  data() {
    return {
      paginationOptions: {
        name: 'article',
        service: 'article',
        searchIn: [
          'title',
          'topic',
        ],
        filters: [
          {
            label: 'Sites',
            type: 'multiselect',
            optionLabel: 'name',
            trackBy: 'id',
            append: value => (value ? {
              siteId: {
                $in: value.map(prop('id')),
              },
            } : {}),
            options: () => this.query('site'),
          },
        ],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Articles",
    "button": "Add an article"
  }
}
</i18n>
